import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * トースト通知サービス
 * APIエラーや成功メッセージをSnackbarで表示する
 */
@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly snackBar = inject(MatSnackBar);
  private queue: {
    message: string;
    type: 'error' | 'success' | 'info' | 'warning';
  }[] = [];
  private isShowing = false;

  /**
   * エラーメッセージを表示
   */
  showError(message: string): void {
    this.queue.push({ message, type: 'error' });
    this.processQueue();
  }

  /**
   * 成功メッセージを表示
   */
  showSuccess(message: string): void {
    this.queue.push({ message, type: 'success' });
    this.processQueue();
  }

  /**
   * 情報メッセージを表示
   */
  showInfo(message: string): void {
    this.queue.push({ message, type: 'info' });
    this.processQueue();
  }

  /**
   * 警告メッセージを表示
   */
  showWarning(message: string): void {
    this.queue.push({ message, type: 'warning' });
    this.processQueue();
  }

  private processQueue(): void {
    if (this.isShowing || this.queue.length === 0) return;

    this.isShowing = true;
    const item = this.queue.shift();
    if (!item) return;

    const panelClass = this.getPanelClass(item.type);

    const snackBarRef = this.snackBar.open(item.message, '閉じる', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: [panelClass],
    });

    snackBarRef.afterDismissed().subscribe(() => {
      this.isShowing = false;
      this.processQueue();
    });
  }

  private getPanelClass(
    type: 'error' | 'success' | 'info' | 'warning',
  ): string {
    switch (type) {
      case 'error':
        return 'error-snackbar';
      case 'success':
        return 'success-snackbar';
      case 'info':
        return 'info-snackbar';
      case 'warning':
        return 'warning-snackbar';
    }
  }
}
